import { put, call, takeLatest, all } from 'redux-saga/effects';

import { formatMDYWithParam } from 'utils/formatDate';
import { DEFAULT_SORT } from 'static/Constants';

import * as services from 'services/workflow';
import * as servicesGrid from 'services/grid';

import * as types from './constants';
import * as actions from './actions';

export function* getWfSelectedStepSaga(action) {
  try {
    const wfImpleStepId = action.payload;

    const response = yield call(services.getWfImplStepInfo, wfImpleStepId);

    const { isSuccess, data, message } = response;

    if (isSuccess) {
      yield put(actions.getWfSelectedStepSuccess(data));
    } else {
      yield put(actions.getWfSelectedStepFail(message));
    }
  } catch (error) {
    yield put(actions.getWfSelectedStepFail(error));
  }
}

export function* getWfImplInfoSaga(action) {
  try {
    const WorkflowImplementId = action.payload;

    const response = yield call(services.getWfImplInfo, WorkflowImplementId);

    const { isSuccess, data, message } = response;

    if (isSuccess) {
      yield put(actions.getWfImplInfoSuccess(data));
    } else {
      yield put(actions.getWfImplInfoFail(message));
    }
  } catch (error) {
    yield put(actions.getWfImplInfoFail(error));
  }
}

export function* getworkflowTasksSaga(action) {
  try {
    const response = yield call(services.getWorkflowImplementTasksInfo, {
      WorkflowImplementationStepId: action.payload,
    });

    const { isSuccess, data, message } = response;
    if (isSuccess) {
      yield put(actions.getWorkflowTasksSuccess(data));
    } else {
      yield put(actions.getWorkflowTasksFail(message));
    }
  } catch (error) {
    yield put(actions.getWorkflowTasksFail(error));
  }
}

export function* getWorkflowGridSaga(payload) {
  try {
    const response = yield call(services.getWorkflowGridService, {
      ...payload.params,
      sort: DEFAULT_SORT,
    });

    const { isSuccess, data, message } = response;

    if (isSuccess) {
      yield put(actions.getWorkflowGridSuccess(data));
    } else {
      yield put(actions.getWorkflowGridError(message));
    }
  } catch (error) {
    yield put(actions.getWorkflowGridError(error));
  }
}

export function* getColumnsFilter(payload) {
  const response = yield call(servicesGrid.gridColumnInfo, payload.gridName);
  return { response };
}

export function* getWorkflowGridColumnSaga(payload) {
  try {
    const { response } = yield call(getColumnsFilter, payload);
    let columns = [
      {
        field: '',
        checkboxSelection: true,
        filter: false,
        suppressHeaderMenuButton: true,
        sortable: false,
      },
    ];

    if (response?.columns?.length > 0) {
      let hiddenCol = ['id'];
      let dateCol = ['created'];

      response.columns.forEach((val) => {
        if (hiddenCol.indexOf(val.fieldNameCamelCase) === -1) {
          if (dateCol.includes(val.fieldNameCamelCase)) {
            val = {
              ...val,
              width: 140,
              cellRenderer: formatMDYWithParam,
              resizable: true,
            };
          } else if (val.fieldNameCamelCase === 'name') {
            val = {
              ...val,
              minWidth: 250,
              resizable: true,
              flex: 1,
            };
          } else if (val.fieldNameCamelCase === 'description') {
            val = {
              ...val,
              width: 300,
              resizable: true,
            };
          } else if (val.fieldNameCamelCase === 'status') {
            val = {
              ...val,
              width: 100,
              resizable: true,
            };
          } else {
            val = { ...val, width: 100, resizable: true };
          }
          columns.push(val);
        }
      });
    }

    yield put(actions.getWorkflowGridColumnsSuccess(columns));
  } catch (error) {
    yield put(actions.getWorkflowGridColumnsError(error));
  }
}

export function* getWfImplStepsSaga(action) {
  try {
    const wfImpleId = action.payload;
    const response = yield call(services.getWfImplSteps, wfImpleId);

    if (response?.isSuccess) {
      yield put(actions.getWfImplStepsSuccess(response?.data));
    } else {
      yield put(actions.getWfImplStepsFail(response?.message));
    }
  } catch (error) {
    yield put(actions.getWfImplStepsFail(error));
  }
}

function* watchAll() {
  yield all([
    takeLatest(types.GET_WORKFLOW_GRID, getWorkflowGridSaga),
    takeLatest(types.GET_WORKFLOW_GRID_COLUMN, getWorkflowGridColumnSaga),
    takeLatest(types.GET_WORKFLOW_SELECTED_STEP, getWfSelectedStepSaga),
    takeLatest(types.GET_WF_IMPL_STEPS, getWfImplStepsSaga),
    takeLatest(types.GET_WF_IMPL_INFO, getWfImplInfoSaga),
    takeLatest(types.GET_WORKFLOW_TASKS_INFO, getworkflowTasksSaga),
  ]);
}

export default watchAll;
